/**
 * The singleton that this file exports is the way to get instances of injectable services in Vue
 * (or anywhere non-Angular).
 *
 * In Angular where you would do:
 * function MyFunction(userService) {
 *     userService.doStuff();
 * }
 * or:
 * $injector.get('userService').doStuff();
 *
 * Elsewhere you can use this file to do:
 * const container = require('@/container');
 * container.userService.doStuff();
 *
 * The `container` contains a property for each thing that you can get from Angular's injector. That provides
 * the typings for your IDE.
 *
 * The first time you access a property (e.g. userService) it will fetch that service from Angular's $injector,
 * and hold on to a copy of it. This prevents repeated requests to Angular and repeatedly constructing classes.
 *
 * This container does not do anything with constructing or resolving dependencies yet. All that is still done by
 * Angular's injector. This is currently only concerned with providing and holding on to instances of services.
 *
 * You can use this in Angular too and the benefit is the IDE will already know the type.
 */

// Note: ServiceContainer is auto generated by Grunt which runs /scripts/code/build-service-container.js
const ServiceContainer = require('@/lib/Services/ServiceContainer');
const { getService } = require('@/lib/DI/injector');

// Create the single instance of the service container.
// This has a bunch of properties like userService, membershipService, etc.
const rawContainer = new ServiceContainer();

// But at this point, if you do:
// container.userService.getUsername();
// You'll just get TypeError: Cannot read properties of undefined (reading 'getUsername')
// because all the values there are 'undefined'.

// Here's the magic:
// Wrap that ServiceContainer instance in a Proxy.
// The Proxy intercepts all calls to get a property. If the value is undefined it will use the getService method to get
// an instance of that service from Angular's injector, and keep hold of it so it is only instantiated once.
/**
 * @type {ServiceContainer}
 */
const container = new Proxy(rawContainer, {
    get(target, prop) {
        if (target[prop] === undefined) {
            target[prop] = getService(prop);
        }

        return target[prop];
    },
});

module.exports = {
    container,
};
